import React from 'react';
import { IconProps } from '../../DefaultIcon';
export function ProfessionalCategoriesIcon({ className }: IconProps) {
  return (
    <svg
      width="104"
      height="69"
      viewBox="0 0 104 69"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1737)">
        <path
          d="M59.2411 62.1038C57.9075 51.8445 51.4462 43.2289 42.5244 38.9211C38.843 41.434 34.4103 42.9077 29.6395 42.9077C24.8687 42.9077 20.4359 41.434 16.7545 38.9211C7.83272 43.2478 1.35267 51.8634 0.0378795 62.1038C-0.225079 64.1821 1.39024 66.0148 3.47512 66.0148H55.8226C57.9075 66.0148 59.5228 64.1821 59.2598 62.1038H59.2411Z"
          fill="#00416B"
        />
        <path
          d="M45.7173 19.8195C45.7173 28.7563 38.5235 35.9926 29.6393 35.9926C20.7551 35.9926 13.5801 28.7563 13.5801 19.8195C13.5801 10.8828 20.7551 3.64648 29.6393 3.64648C38.5235 3.64648 45.7173 10.8828 45.7173 19.8195Z"
          fill="#00416B"
        />
        <path
          d="M104 14.1892C103.681 11.6952 102.103 9.61689 99.9431 8.55884C99.0603 9.16344 97.9709 9.52242 96.8251 9.52242C95.6794 9.52242 94.59 9.16344 93.7072 8.55884C91.5472 9.59799 89.9694 11.6952 89.6501 14.1892C89.5938 14.6993 89.9694 15.1339 90.4766 15.1339H103.174C103.681 15.1339 104.075 14.6804 104 14.1892Z"
          fill="#5FD6C3"
        />
        <path
          d="M100.713 3.9299C100.713 6.10268 98.9662 7.8598 96.8062 7.8598C94.6462 7.8598 92.8994 6.10268 92.8994 3.9299C92.8994 1.75712 94.6462 0 96.8062 0C98.9662 0 100.713 1.75712 100.713 3.9299Z"
          fill="#5FD6C3"
        />
        <path
          d="M104 41.5661C103.681 39.0722 102.103 36.9938 99.9431 35.9358C99.0603 36.5404 97.9709 36.8994 96.8251 36.8994C95.6794 36.8994 94.59 36.5404 93.7072 35.9358C91.5472 36.9749 89.9694 39.0722 89.6501 41.5661C89.5938 42.0763 89.9694 42.5108 90.4766 42.5108H103.174C103.681 42.5108 104.075 42.0574 104 41.5661Z"
          fill="#5FD6C3"
        />
        <path
          d="M100.713 31.3069C100.713 33.4796 98.9662 35.2368 96.8062 35.2368C94.6462 35.2368 92.8994 33.4796 92.8994 31.3069C92.8994 29.1341 94.6462 27.377 96.8062 27.377C98.9662 27.377 100.713 29.1341 100.713 31.3069Z"
          fill="#5FD6C3"
        />
        <path
          d="M104 68.0554C103.681 65.5614 102.103 63.4831 99.9431 62.425C99.0603 63.0296 97.9709 63.3886 96.8251 63.3886C95.6794 63.3886 94.59 63.0296 93.7072 62.425C91.5472 63.4642 89.9694 65.5614 89.6501 68.0554C89.5938 68.5655 89.9694 69.0001 90.4766 69.0001H103.174C103.681 69.0001 104.075 68.5466 104 68.0554Z"
          fill="#5FD6C3"
        />
        <path
          d="M100.713 57.7961C100.713 59.9689 98.9662 61.726 96.8062 61.726C94.6462 61.726 92.8994 59.9689 92.8994 57.7961C92.8994 55.6233 94.6462 53.8662 96.8062 53.8662C98.9662 53.8662 100.713 55.6233 100.713 57.7961Z"
          fill="#5FD6C3"
        />
        <path
          d="M88.0347 8.46449C88.0347 9.82484 86.9453 10.9207 85.5929 10.9207H70.2286C68.7448 10.9207 67.5427 12.1299 67.5427 13.6225V29.0965C67.5427 30.4568 66.4533 31.5527 65.1009 31.5527C63.7486 31.5527 62.6592 30.4568 62.6592 29.0965V13.6225C62.6592 9.42807 66.0589 6.0083 70.2286 6.0083H85.5929C86.9453 6.0083 88.0347 7.10414 88.0347 8.46449Z"
          fill="#EAEDF8"
        />
        <path
          d="M88.0347 61.4424C88.0347 62.8028 86.9453 63.8986 85.5929 63.8986H70.2286C66.0589 63.8986 62.6592 60.4788 62.6592 56.2844V40.8104C62.6592 39.4501 63.7486 38.3542 65.1009 38.3542C66.4533 38.3542 67.5427 39.4501 67.5427 40.8104V56.2844C67.5427 57.777 68.7448 58.9862 70.2286 58.9862H85.5929C86.9453 58.9862 88.0347 60.0821 88.0347 61.4424Z"
          fill="#EAEDF8"
        />
        <path
          d="M64.9885 37.3152H85.687C86.983 37.3152 88.0349 36.2572 88.0349 34.9535C88.0349 33.6498 86.983 32.5918 85.687 32.5918H64.9885C63.6925 32.5918 62.6406 33.6498 62.6406 34.9535C62.6406 36.2572 63.6925 37.3152 64.9885 37.3152Z"
          fill="#EAEDF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1737">
          <rect width="104" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
